
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/musik/[...params]",
      function () {
        return require("private-next-pages/musik/[...params].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/musik/[...params]"])
      });
    }
  